<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction" />
    <div class="inner">
      <h1 v-translate>Zařízení</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <div class="field_left">
          <search-input
              input-class="search"
              v-model="formFields.mac_address"
              :label="$gettext('MAC adresa')"
          />
        </div>
        <div :class="{'field_left': !showOperatorFilter, 'field_right': showOperatorFilter}">
          <select-box
              id="device_type"
              :options="deviceTypesOptions"
              v-model="formFields.id_type"
              ref="iddevicetyperef"
          >
            <translate class="translate">Typ zařízení</translate>
          </select-box>
        </div>
        <div class="field_left"
             v-if="$_loggedUser_action_allowed('brands') && !this.$store.getters.getSelectedOperatorId">
          <select-box
              id="brand"
              :options="brandOptions"
              v-model="formFields.id_brand"
              ref="idbrandref"
          >
            <translate class="translate">Brand</translate>
          </select-box>
        </div>
        <div class="field_right" v-if="$_loggedUser_action_allowed('deviceProfiles')">
          <select-box
              id="device_profile"
              :options="deviceProfilesOptions"
              v-model="formFields.id_profile"
              ref="idprofileref"
          >
            <translate class="translate">Profil zařízení</translate>
          </select-box>
        </div>
        <div class="field_left">
          <date-picker
              id="last_start_from"
              attrKey="last_start_from"
              date-format="d. m. yy"
              v-model="formFields.last_start_from"
              @update-date="updateFormDate"
          >
            <translate class="translate">Poslední start od</translate>
          </date-picker>
        </div>
        <div class="field_right">
          <date-picker
              id="created_from"
              attrKey="created_from"
              date-format="d. m. yy"
              v-model="formFields.created_from"
              @update-date="updateFormDate"
          >
            <translate class="translate">Vytvořeno od</translate>
          </date-picker>
        </div>
        <div class="field_left">
          <date-picker
              id="last_start_to"
              attrKey="last_start_to"
              date-format="d. m. yy"
              v-model="formFields.last_start_to"
              @update-date="updateFormDate"
          >
            <translate class="translate">Poslední start do</translate>
          </date-picker>
        </div>
        <div class="field_right">
          <date-picker
              id="created_to"
              attrKey="created_to"
              date-format="d. m. yy"
              v-model="formFields.created_to"
              @update-date="updateFormDate"
          >
            <translate class="translate">Vytvořeno do</translate>
          </date-picker>
        </div>
        <div class="field_left field_full">
          <div class="field checkboxes">
            <filter-checkbox
                key="pre_provisioned"
                id="pre_provisioned"
                name="pre_provisioned"
                :val="1"
                v-model="formFields.pre_provisioned"
            >
              <translate class="translate">Přednastavený</translate>
            </filter-checkbox>
            <filter-checkbox
                key="service_device"
                id="service_device"
                name="service_device"
                :val="1"
                v-model="formFields.service_device"
                v-if="$_loggedUser_action_allowed('serviceDevices', 'create')"
            >
              <translate class="translate">Servisní zařízení</translate>
            </filter-checkbox>
          </div>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
           :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="devices-list">
          <table class="vypis vypis_detail">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"/>
              <th class="no_padding checkbox"/>
              <sorting-table-title
                  v-for="title in devicesTableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  :extraStyle="title.style"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"/>
            </tr>
            </thead>

            <device-row
                v-for="device in entities"
                :entity="device"
                :key="device.id"
                @deleteDevice="deleteEntity"
                @input="select"
                :selectedDevices="selectedEntities"
                :deviceLogViewerUrl="deviceLogViewerUrl"
                :ref="'device-row-ref-'+device.id"
            ></device-row>

            <tr v-if="entities.length === 0">
              <td colspan="8">{{ $gettext('Nebyla nalezena žádná zařízení.') }}</td>
            </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="devices-list"
          @run-multiple-action="executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          @select-all="toggleSelectAll"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import DeviceRow from "@/components/views/devices/DeviceRow"
import listActions from "@/components/mixins/list-actions"
import {prependOptions} from "@/utils/helpers";

export default {
  name: "DevicesList",
  components: {
    DeviceRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'devices',
      entitiesKey: 'devices',
      dateFields: ['created_from', 'created_to', 'last_start_from', 'last_start_to'],
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        },
        id_profile: 0,
        id_type: 0,
        id_brand: 0,
        created_from: null,
        created_to: null,
        last_start_from: null,
        last_start_to: null,
        mac_address: null,
        pre_provisioned: null,
        service_device: null,
      },
      device_profiles: [],
      device_types: [],
      brands: [],
      deviceLogViewerUrl: '',
    }
  },
  created(DeviceService, DeviceProfileService, DeviceTypeService, BrandService) {
    this.entityService = DeviceService;
    this.deviceProfileService = DeviceProfileService;
    this.deviceTypeService = DeviceTypeService;
    this.brandService = BrandService;

    this.deviceTypeService.getEntitiesForSelectBox()
        .then((data) => {
          this.device_types = data['device_types']
        })
        .catch((error) => {
          this.setErrorMessage(error['error_message']);
        })

    if (this.$_loggedUser_action_allowed('deviceProfiles', 'read')) {
      this.deviceProfileService.getEntitiesForSelectBox()
          .then((data) => {
            this.device_profiles = data['device_profiles']
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message']);
          })
    }

    if (this.$_loggedUser_action_allowed('brands', 'read')) {
      this.brandService.getEntitiesForSelectBox()
          .then((data) => {
            this.brands = data['brands']
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message']);
          })
    }

    this.createdInit()
  },
  computed: {

    multipleActionOptions() {
      let options = [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        {value: 'exportCsvWithSubscriber', text: this.$gettext('Exportovat do CSV s údaji o odběratelích')}
      ];
      if(this.$_updateActionAllowed){
        options.push({value: 'softrestart', text: this.$gettext('Soft restart')});
        options.push({value: 'hardrestart', text: this.$gettext('Hard restart')});
        options.push({value: 'forcefullreload', text: this.$gettext('Force full reload')});
      }
      if(this.$_deleteActionAllowed){
        options.push({value: 'delete', text: this.$gettext('Smazat')});
      }

      return options;
    },
    devicesTableTitles() {
      return this.$_readActionAllowedAll ? this.ownerTableTitles : this.operatorTableTitles;
    },
    showOperatorFilter(){
      return this.$_loggedUser_action_allowed('operators') && this.$_loggedUser_canChangeOperator && !this.$_loggedUser_isChangedOperator;
    },
    ownerTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název zařízení'), column: 'sName', style: {minWidth: '130px'}},
        {key: 2, name: this.$gettext('MAC'), column: 'sMacAddress'},
        {key: 3, name: this.$gettext('Model'), column: 'sModel'},
        {key: 4, name: this.$gettext('Firmware a aplikace'), column: 'sFirmware'},
        {key: 5, name: this.$gettext('Sériové číslo'), column: 'sSerialNumber'},
        {key: 6, name: this.$gettext('Typ'), column: 'sTypeName'},
        {key: 7, name: this.$gettext('Profil'), column: 'sProfileName'},
        {key: 8, name: this.$gettext('Odběratel'), column: 'sSubscriberName'},
        {key: 9, name: this.$gettext('Operátor'), column: 'sOperatorName'},
        {key: 10, name: this.$gettext('Poslední start'), column: 'sLastStart'},
        {key: 11, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
      ];
    },
    operatorTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název zařízení'), column: 'sName'},
        {key: 2, name: this.$gettext('MAC'), column: 'sMacAddress'},
        {key: 3, name: this.$gettext('Model'), column: 'sModel'},
        {key: 4, name: this.$gettext('Firmware a aplikace'), column: 'sFirmware'},
        {key: 5, name: this.$gettext('Sériové číslo'), column: 'sSerialNumber'},
        {key: 6, name: this.$gettext('Typ'), column: 'sTypeName'},
        {key: 7, name: this.$gettext('Profil'), column: 'sProfileName'},
        {key: 8, name: this.$gettext('Odběratel'), column: 'sSubscriberName'},
        {key: 9, name: this.$gettext('Poslední start'), column: 'sLastStart'},
        {key: 10, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
      ]
    },
    deviceProfilesOptions() {
      if (this.device_profiles) {
        return prependOptions(this._.map(this.device_profiles, function (item) {
          return {id: item['id'], text: item['name']}
        }), this.$gettext('Všechny'))
      } else {
        return []
      }
    },
    deviceTypesOptions() {
      if (this.device_types) {
        return prependOptions(this._.map(this.device_types, function (item) {
          return {id: item['id'], text: item['name']}
        }), this.$gettext('Všechny'))
      } else {
        return []
      }
    },
    brandOptions() {
      if (this.brands) {
        return prependOptions(this._.map(this.brands, function (item) {
          return {id: item['id'], text: item['name']}
        }), this.$gettext('Všechny'))
      } else {
        return []
      }
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.devicesTableTitles)
      headers.mac_address.callback = (entity) => {return entity.last_used_mac_address; };
      headers.last_start.callback = (entity) => {return entity.last_start ? this.$_datetime_format(entity.last_start) : ''};

      return headers;
    },

    csvDetailHeaders(){
      let headers = this.csvHeaders;
      headers['id_subscriber'] = {name: 'ID odběratele'};
      headers['remote_id_subscriber'] = {name: 'Vzdálené ID odběratele'};
      headers['login'] = {name: 'Login odběratele'};

      return headers;
    },
  },
  methods: {
    _afterGetEntitiesActions(data){
      this.deviceLogViewerUrl = data.device_log_viewer_url;
    },
    executeMultipleAction(action, activeKey) {
        let actionIds = this.filteredSelectedEntities.join();

      switch (action) {
        case 'softrestart':
          this.entityService.restartDevices(actionIds, "soft").then((data) => {
            this.setSuccessMessage(this.$gettextInterpolate(this.$gettext('K soft restartování označeno %{count} zařízení.'), {
              count: data.count
            }));
          });
          break;
        case 'hardrestart':
          this.entityService.restartDevices(actionIds, "hard").then((data) => {
            this.setSuccessMessage(this.$gettextInterpolate(this.$gettext('K hard restartování označeno %{count} zařízení.'), {
              count: data.count
            }));
          });
          break;
        case 'forcefullreload':
          this.entityService.forceFullReloadDevices(actionIds).then((data) => {
            this.setSuccessMessage(this.$gettextInterpolate(this.$gettext('K přenačtení označeno %{count} zařízení.'), {
              count: data.count
            }));
          });
          break;
        case 'exportCsvWithSubscriber':
            this._exportDetailCsv();
          break;
        default:
          this.runMultipleAction(action, activeKey);
      }
    },
    _exportDetailCsv(){
      this.setLoadingMessage()
      let formFields = this._processFormFields(this.getFormFields());
      delete formFields.limit;
      delete formFields.offset;

      this.entityService.getEntities(formFields).then(responseData => {
        let entities = responseData[this.entitiesKey !== null ? this.entitiesKey : this.moduleName];
        this._createExportCsv(this.csvDetailHeaders, entities);
      });
    },
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.$_loggedUser_action_allowed('deviceTypes') && this.loadDefaultByKey('id_type')) {
        anyChanges = true
      }
      if (this.$_loggedUser_action_allowed('deviceTypes')
          && !this.$store.getters.getSelectedOperatorId
          && this.loadDefaultByKey('id_brand')
      ) {
        anyChanges = true
      }
      if (this.$_loggedUser_action_allowed('deviceProfiles') && this.loadDefaultByKey('id_profile')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('created_from')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('created_to')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('last_start_from')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('last_start_to')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('mac_address')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('pre_provisioned')) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('service_device')) {
        anyChanges = true
      }
      return anyChanges
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
      this.setUserSetting('id_type', this.formFields.id_type);
      this.setUserSetting('id_brand', this.formFields.id_brand);
      this.setUserSetting('id_profile', this.formFields.id_profile);
      this.setUserSetting('created_from', this.formFields.created_from);
      this.setUserSetting('created_to', this.formFields.created_to);
      this.setUserSetting('last_start_from', this.formFields.last_start_from);
      this.setUserSetting('last_start_to', this.formFields.last_start_to);
      this.setUserSetting('mac_address', this.formFields.mac_address);
      this.setUserSetting('pre_provisioned', this.formFields.pre_provisioned);
      this.setUserSetting('service_device', this.formFields.service_device);
    },
    updateFormDate(dateInfo) {
      this.formFields[dateInfo.attrKey] = dateInfo.date
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/DevicesList.vue